import React, { useEffect } from "react";
import LinkTwoToneIcon from "@mui/icons-material/LinkTwoTone";
import HistoryTwoToneIcon from "@mui/icons-material/HistoryTwoTone";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarContent,
  SidebarHeader,
} from "react-pro-sidebar";
import { useAppDispatch, useAppSelector } from "../useStore";
import { applicationassigned } from "../features/Applicant/applicantSlice";

const InsightSideBar = (Props: any, setActive: unknown) => {
  const dispatch = useAppDispatch();
  const [actives, setActives] = React.useState("/activeinterview");
  const { applicationassigneddata } = useAppSelector((state: any) => state.applicant)



  useEffect(() => {
    dispatch(applicationassigned())
  }, [dispatch])

  useEffect(() => {
    Props.setActive(actives);
  }, [Props, actives, setActive]);




  const screeninghistory = applicationassigneddata?.data?.filter((obj: any) => {
    return obj?.ScreeningLog?.screeningStatus === "COMPLETED"
  })
  const evaluationhistory = applicationassigneddata?.data?.filter((obj: any) => {
    return obj?.EvaluatingLog?.evaluatingStatus === "COMPLETED"
  })
  const sidebarList = [
    {
      title: "Tasks",
      icon: <LinkTwoToneIcon />,
      metric: !applicationassigneddata?.data?.length ? '0' : applicationassigneddata?.data?.length,
      path: "/tasks",
    },
    {
      title: "Screening History",
      icon: <HistoryTwoToneIcon />,
      metric: !screeninghistory?.length ? "0" : screeninghistory?.length,
      path: "/screeninghistory",
    },
    {
      title: "Evaluation History",
      icon: <HistoryTwoToneIcon />,
      metric: !evaluationhistory?.length ? "0" : evaluationhistory?.length,
      path: "/evaluationhistory",
    },
  ];

  return (
    <div id="Sidenavbar">
      <div id="SideBar__container">
        <div className="SideBar__content">
          <ProSidebar>
            <SidebarHeader>
              <h4>My Task</h4>
            </SidebarHeader>
            <SidebarContent>
              <Menu>
                {sidebarList.map((item, i) => (
                  <MenuItem
                    key={i}
                    className="Side__Content"
                    active={item.path === actives}
                    icon={item.icon}
                    suffix={item.metric}
                    onClick={() => setActives(item.path)}
                  >
                    {item.title}
                  </MenuItem>
                ))}
              </Menu>
            </SidebarContent>
          </ProSidebar>
        </div>
      </div>
    </div>
  );
};
export default InsightSideBar;
